module.exports = __webpack_public_path__ + "img/bio-photo-04.5ea4c628.jpg";